export default __webpack_public_path__ + "static/media/gridImage4.49a8d866.jpg";